// assets/eg-quote-bridge.js
(() => {
  "use strict";

  if (window.__EG_QUOTE_BRIDGE_BOUND__) return;
  window.__EG_QUOTE_BRIDGE_BOUND__ = true;

  const EG_PROXY_BASE = "/apps/eg-booking";
  const QUOTE_URL = `${EG_PROXY_BASE}/quote`;

  const DEBUG = true;

  const $ = (sel, root = document) => root.querySelector(sel);

  function log(...args) {
    if (DEBUG) console.log("[EG quote-bridge]", ...args);
  }

  function warn(...args) {
    console.warn("[EG quote-bridge]", ...args);
  }

  function findRoot(rootId) {
    if (rootId) {
      const byId = document.getElementById(rootId);
      if (byId) return byId;
    }

    return (
      document.getElementById("eg-calendar-root") ||
      document.querySelector("[data-eg-booking]") ||
      document.querySelector("[data-eg-booking-root]") ||
      document.querySelector("[data-eg-calendar-root]") ||
      document.querySelector("[data-eg-calendar]") ||
      document.querySelector("[data-eg-rental-card]") ||
      null
    );
  }

  function findRentalScope(rootEl) {
    return (
      rootEl?.closest?.("[data-eg-rental-card]") ||
      rootEl?.closest?.(".shopify-section") ||
      rootEl?.closest?.("section") ||
      rootEl ||
      document
    );
  }

  function findATCForm(rootEl) {
    const scope = findRentalScope(rootEl);

    const btn =
      scope.querySelector("button.rent-atc") ||
      scope.querySelector('button[name="add"].rent-atc') ||
      scope.querySelector('button[name="add"]') ||
      scope.querySelector('button[type="submit"]') ||
      scope.querySelector('input[type="submit"]');

    const formFromBtn = btn?.closest?.('form[action*="/cart/add"]');
    if (formFromBtn) return { form: formFromBtn, btn };

    const forms = [...scope.querySelectorAll('form[action*="/cart/add"]')];
    if (forms.length === 1) {
      const b = forms[0].querySelector('button[name="add"], button[type="submit"], input[type="submit"]');
      return { form: forms[0], btn: b };
    }

    const preferred =
      forms.find((f) => (f.id || "").startsWith("product-form-")) ||
      forms[0] ||
      null;

    const b =
      preferred?.querySelector('button[name="add"], button[type="submit"], input[type="submit"]') ||
      null;

    return {
      form: preferred || $('form[action*="/cart/add"]', scope),
      btn: b
    };
  }

  function ensureHidden(form, name) {
    if (!form) return null;

    let el;
    try {
      el = form.querySelector(`input[name="${CSS.escape(name)}"]`);
    } catch (_) {
      el = form.querySelector(`input[name="${name}"]`);
    }

    if (!el) {
      el = document.createElement("input");
      el.type = "hidden";
      el.name = name;
      form.appendChild(el);
    }
    return el;
  }

  function setToken(form, token) {
    const safe = token ? String(token) : "";

    const a = ensureHidden(form, "eg_quote_token");
    if (a) a.value = safe;

    const b = ensureHidden(form, "properties[eg_quote_token]");
    if (b) b.value = safe;

    window.egQuoteToken = safe || null;
    log("setToken:", safe ? "[token set]" : "[token cleared]");
  }

  function setATCEnabled(btn, enabled) {
    if (!btn) return;

    btn.disabled = !enabled;
    if (enabled) {
      btn.removeAttribute("aria-disabled");
      btn.classList.remove("is-disabled", "disabled");
    } else {
      btn.setAttribute("aria-disabled", "true");
      btn.classList.add("is-disabled");
    }
  }

  function resolveCity(root) {
    const scope = findRentalScope(root);

    const candidates = [
      root?.dataset?.city,
      scope?.dataset?.city,
      document.documentElement.getAttribute("data-city"),
      localStorage.getItem("lastCity"),
      localStorage.getItem("eg_city")
    ];

    for (const v of candidates) {
      const s = String(v || "").trim();
      if (s) return s.toLowerCase();
    }

    return "";
  }

  function resolveProductId(root) {
    const scope = findRentalScope(root);
    const formInfo = findATCForm(root);
    const form = formInfo?.form;

    const candidates = [
      root?.dataset?.productId,
      root?.dataset?.product_id,
      scope?.dataset?.productId,
      scope?.dataset?.product_id,
      form?.dataset?.productId,
      form?.dataset?.product_id,
      $('input[name="product_id"]', form)?.value,
      $('input[name="product-id"]', form)?.value,
      $('input[name="id"]', form)?.dataset?.productId
    ];

    for (const v of candidates) {
      const s = String(v || "").trim();
      if (s) return s;
    }

    return "";
  }

  function parseVariants(root) {
    const scope = findRentalScope(root);

    const sources = [
      root?.getAttribute?.("data-eg-variants"),
      scope?.getAttribute?.("data-eg-variants"),
      $('#eg-variants-json', scope)?.textContent
    ];

    for (const raw of sources) {
      if (!raw) continue;
      try {
        const arr = JSON.parse(raw);
        if (Array.isArray(arr)) return arr;
      } catch (_) {}
    }

    return [];
  }

  function getSelectedVariantId(root) {
    const { form } = findATCForm(root);
    if (!form) return "";

    const el =
      form.querySelector('input[name="id"]') ||
      form.querySelector('select[name="id"]') ||
      form.querySelector('[name="id"]');

    return String(el?.value || "").trim();
  }

  function resolveT1PriceCents(root) {
    const variants = parseVariants(root);
    if (!variants.length) return 0;

    const selectedVariantId = getSelectedVariantId(root);

    const normalized = variants
      .map((v) => ({
        id: String(v?.id || "").trim(),
        price: Number(v?.price || 0),
        title: String(v?.title || v?.name || "").toLowerCase()
      }))
      .filter((v) => Number.isFinite(v.price) && v.price > 0);

    if (!normalized.length) return 0;

    const explicitT1 =
      normalized.find((v) => v.title.includes("t1")) ||
      normalized.find((v) => v.title.includes("100%")) ||
      normalized.find((v) => v.title.includes("fullpris")) ||
      null;

    if (explicitT1) return explicitT1.price;

    if (selectedVariantId) {
      const selected = normalized.find((v) => v.id === selectedVariantId);
      if (selected) return selected.price;
    }

    return Math.max(...normalized.map((v) => v.price));
  }

  function findUnitsInput(root) {
    const scope = findRentalScope(root);

    return (
      scope.querySelector('[data-eg-units-input]') ||
      scope.querySelector('input[name="eg_units"]') ||
      scope.querySelector('input[name="units"]') ||
      scope.querySelector('quantity-input input[type="number"]:not([type="hidden"])') ||
      scope.querySelector('input[name="quantity"][type="number"]:not([type="hidden"])') ||
      scope.querySelector('input.qty') ||
      scope.querySelector('input.quantity') ||
      document.querySelector('[data-eg-units-input]') ||
      document.querySelector('input[name="eg_units"]') ||
      document.querySelector('input[name="units"]') ||
      document.querySelector('quantity-input input[type="number"]:not([type="hidden"])') ||
      document.querySelector('input[name="quantity"][type="number"]:not([type="hidden"])') ||
      null
    );
  }

  function findHiddenQuantityInput(root) {
    const scope = findRentalScope(root);

    return (
      scope.querySelector('input[name="quantity"][type="hidden"]') ||
      scope.querySelector('input[name="quantity"]:not([type="number"])') ||
      document.querySelector('input[name="quantity"][type="hidden"]') ||
      null
    );
  }

  function syncQuantityInputs(root, units) {
    const visible = findUnitsInput(root);
    const hidden = findHiddenQuantityInput(root);

    if (visible && String(visible.value) !== String(units)) {
      visible.value = String(units);
    }
    if (hidden && String(hidden.value) !== String(units)) {
      hidden.value = String(units);
    }
  }

  function getUnitsMax(root) {
    const visible = findUnitsInput(root);

    const max = Number(
      visible?.max ||
      visible?.getAttribute?.("max") ||
      visible?.dataset?.max ||
      1
    );

    return Number.isFinite(max) && max > 0 ? Math.floor(max) : 1;
  }

  function resolveUnits(root, detail) {
    const fromDetail = Number(detail?.units);
    let units = Number.isFinite(fromDetail) && fromDetail > 0
      ? Math.floor(fromDetail)
      : NaN;

    if (!Number.isFinite(units)) {
      const qtyInput = findUnitsInput(root);
      units = Number(qtyInput?.value || 1);
    }

    if (!Number.isFinite(units) || units < 1) {
      units = 1;
    }

    const maxUnits = getUnitsMax(root);
    if (units > maxUnits) {
      units = maxUnits;
    }

    syncQuantityInputs(root, units);
    return units;
  }

  function formatSek(cents) {
    const n = Number(cents || 0) / 100;
    return `${n.toLocaleString("sv-SE")} SEK`;
  }

  function normalizeQuote(raw) {
    if (!raw || typeof raw !== "object") return null;

    const subtotal = Number(raw.subtotal_cents ?? raw.line_price_cents ?? 0);
    const addons = Number(raw.addons_total_cents ?? 0);
    const total = Number(raw.total_cents ?? raw.total_price_cents ?? 0);

    let discount = Number(raw.discount_cents ?? 0);

    const billedDays = Number(raw.billed_days ?? 0);
    const units = Number(raw.units ?? 0);
    const discountMultiplier = Number(raw.discount_multiplier ?? 0);

    if ((!discount || discount < 0) && total >= 0 && subtotal >= 0) {
      const inferred = subtotal + addons - total;
      if (Number.isFinite(inferred) && inferred > 0) {
        discount = inferred;
      }
    }

    let safeSubtotal = subtotal;
    const variantPrice = Number(raw.variant_price_cents ?? 0);
    if ((!safeSubtotal || safeSubtotal <= 0) && billedDays > 0 && units > 0 && variantPrice > 0) {
      safeSubtotal = billedDays * units * variantPrice;
    }

    return {
      token: raw.token ? String(raw.token) : "",
      billed_days: billedDays,
      units,
      tier: String(raw.tier || ""),
      discount_multiplier: discountMultiplier,
      subtotal_cents: safeSubtotal,
      addons_total_cents: addons,
      discount_cents: discount,
      total_cents: total
    };
  }

  function updatePriceBox(rawQuote, root) {
    const scope = findRentalScope(root);

    const baseEl =
      scope.querySelector('[data-eg-price-base]') ||
      scope.querySelector('.eg-price-base');

    const addonsEl =
      scope.querySelector('[data-eg-price-addons]') ||
      scope.querySelector('.eg-price-addons');

    const subtotalEl =
      scope.querySelector('[data-eg-price-subtotal]') ||
      scope.querySelector('.eg-price-subtotal');

    const discountEl =
      scope.querySelector('[data-eg-price-discount]') ||
      scope.querySelector('.eg-price-discount');

    const totalEl =
      scope.querySelector('[data-eg-price-total]') ||
      scope.querySelector('.eg-price-total');

    const tierEl =
      scope.querySelector('[data-eg-price-tier]') ||
      scope.querySelector('.eg-price-tier');

    const daysEl =
      scope.querySelector('[data-eg-price-days]') ||
      scope.querySelector('.eg-price-days');

    const unitsEl =
      scope.querySelector('[data-eg-price-units]') ||
      scope.querySelector('.eg-price-units');

    const quote = normalizeQuote(rawQuote);

    if (!quote) {
      if (baseEl) baseEl.textContent = "—";
      if (addonsEl) addonsEl.textContent = "—";
      if (subtotalEl) subtotalEl.textContent = "—";
      if (discountEl) discountEl.textContent = "—";
      if (totalEl) totalEl.textContent = "—";
      if (tierEl) tierEl.textContent = "—";
      if (daysEl) daysEl.textContent = "—";
      if (unitsEl) unitsEl.textContent = "—";
      return;
    }

    const subtotal = Number(quote.subtotal_cents || 0);
    const addons = Number(quote.addons_total_cents || 0);
    const discount = Number(quote.discount_cents || 0);
    const total = Number(quote.total_cents || 0);

    if (baseEl) baseEl.textContent = formatSek(subtotal);
    if (addonsEl) addonsEl.textContent = formatSek(addons);
    if (subtotalEl) subtotalEl.textContent = formatSek(subtotal + addons);
    if (discountEl) discountEl.textContent = discount > 0 ? `- ${formatSek(discount)}` : "0 SEK";
    if (totalEl) totalEl.textContent = formatSek(total);
    if (tierEl) tierEl.textContent = quote.tier || "—";
    if (daysEl) daysEl.textContent = quote.billed_days ? String(quote.billed_days) : "—";
    if (unitsEl) unitsEl.textContent = quote.units ? String(quote.units) : "—";
  }

  function emitQuote(rootId, quoteObjOrNull) {
    try {
      window.dispatchEvent(
        new CustomEvent("eg:quote", {
          detail: {
            rootId: rootId || "eg-calendar-root",
            quote: quoteObjOrNull || null
          }
        })
      );
    } catch (_) {}
  }

  function emitQuoteError(rootId, message, extra = {}) {
    try {
      window.dispatchEvent(
        new CustomEvent("eg:quote:error", {
          detail: {
            rootId: rootId || "eg-calendar-root",
            message: String(message || "Quote error"),
            ...extra
          }
        })
      );
    } catch (_) {}
  }

  let lastKey = "";
  let activeController = null;
  const lastGoodQuoteByRoot = new Map();
  const lastDatesByRoot = new Map();

  function rememberGoodQuote(rootId, data) {
    if (!rootId || !data) return;
    lastGoodQuoteByRoot.set(String(rootId), data);
  }

  function getGoodQuote(rootId) {
    return lastGoodQuoteByRoot.get(String(rootId || "eg-calendar-root")) || null;
  }

  function rememberDates(rootId, data) {
    if (!rootId) return;
    lastDatesByRoot.set(String(rootId), {
      rootId: String(rootId),
      start: String(data?.start || data?.start_date || "").trim(),
      end: String(data?.end || data?.end_date || "").trim()
    });
  }

  function getRememberedDates(rootId) {
    return lastDatesByRoot.get(String(rootId || "eg-calendar-root")) || null;
  }

  async function handleDatesEvent(e) {
    const d = e?.detail || {};

    const rootId = String(d.rootId || "eg-calendar-root");
    const start = String(d.start || d.start_date || "").trim();
    const end = String(d.end || d.end_date || "").trim();
    const hasError = !!d.error;

    if (start && end && !hasError) {
      rememberDates(rootId, { start, end });
    }

    const root = findRoot(rootId);
    const { form, btn } = findATCForm(root);

    log("dates event:", {
      rootId,
      start,
      end,
      hasError,
      rootFound: !!root,
      formFound: !!form,
      btnFound: !!btn
    });

    if (!root) {
      warn("No root found for event rootId:", rootId);
      setToken(form, "");
      setATCEnabled(btn, false);
      updatePriceBox(null, document);
      emitQuote(rootId, null);
      emitQuoteError(rootId, "No booking root found");
      return;
    }

    if (!start || !end || hasError) {
      setToken(form, "");
      setATCEnabled(btn, false);
      updatePriceBox(null, root);
      emitQuote(rootId, null);
      return;
    }

    const product_id = resolveProductId(root);
    const city = resolveCity(root);
    const units = resolveUnits(root, d);
    const variant_price_cents = resolveT1PriceCents(root);
    const maxUnits = getUnitsMax(root);

    if (!product_id) {
      warn("Missing product_id");
      setToken(form, "");
      setATCEnabled(btn, false);
      updatePriceBox(null, root);
      emitQuote(rootId, null);
      emitQuoteError(rootId, "Missing product_id");
      return;
    }

    if (!variant_price_cents) {
      warn("Missing variant_price_cents");
      setToken(form, "");
      setATCEnabled(btn, false);
      updatePriceBox(null, root);
      emitQuote(rootId, null);
      emitQuoteError(rootId, "Missing variant_price_cents");
      return;
    }

    if (!Number.isFinite(units) || units < 1) {
      warn("Invalid units after resolve");
      setATCEnabled(btn, false);
      emitQuoteError(rootId, "Invalid units");
      return;
    }

    if (units > maxUnits) {
      syncQuantityInputs(root, maxUnits);
      setATCEnabled(btn, false);
      emitQuoteError(rootId, "Requested units exceed max", {
        units,
        maxUnits
      });
      return;
    }

    const payload = {
      product_id,
      city,
      start_date: start,
      end_date: end,
      units,
      variant_price_cents
    };

    const key = [product_id, city, start, end, units, variant_price_cents].join("|");
    if (key === lastKey) {
      log("Skipping duplicate quote key:", key);

      const goodQuote = getGoodQuote(rootId);
      if (goodQuote) {
        updatePriceBox(goodQuote, root);
        if (goodQuote.token) {
          setToken(form, goodQuote.token);
          setATCEnabled(btn, true);
        }
        emitQuote(rootId, goodQuote);
      }

      return;
    }
    lastKey = key;

    if (activeController) {
      activeController.abort();
    }
    activeController = new AbortController();
    const signal = activeController.signal;

    setATCEnabled(btn, false);
    setToken(form, "");

    try {
      log("POST", QUOTE_URL, payload);

      const res = await fetch(QUOTE_URL, {
        method: "POST",
        credentials: "same-origin",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "X-Requested-With": "XMLHttpRequest"
        },
        body: JSON.stringify(payload),
        signal
      });

      const rawText = await res.text();
      let data = {};

      try {
        data = rawText ? JSON.parse(rawText) : {};
      } catch (_) {
        data = { raw: rawText };
      }

      log("quote response:", { status: res.status, ok: res.ok, data });

      if (signal.aborted) return;

      if (res.ok && data && data.token) {
        setToken(form, data.token);
        setATCEnabled(btn, true);
        updatePriceBox(data, root);
        emitQuote(rootId, data);
        rememberGoodQuote(rootId, data);

        const normalized = normalizeQuote(data);
        if (normalized?.units) {
          syncQuantityInputs(root, normalized.units);
        }
        return;
      }

      const goodQuote = getGoodQuote(rootId);

      setToken(form, "");
      setATCEnabled(btn, false);

      if (goodQuote) {
        updatePriceBox(goodQuote, root);
      }

      emitQuote(rootId, null);
      emitQuoteError(rootId, `Quote failed (${res.status})`, {
        response: data,
        preservedPreviousQuote: !!goodQuote
      });

      lastKey = "";
    } catch (err) {
      if (err?.name === "AbortError") {
        log("Previous quote request aborted");
        return;
      }

      warn("Quote request failed:", err);

      const goodQuote = getGoodQuote(rootId);

      setToken(form, "");
      setATCEnabled(btn, false);

      if (goodQuote) {
        updatePriceBox(goodQuote, root);
      }

      emitQuote(rootId, null);
      emitQuoteError(rootId, err?.message || "Network error", {
        preservedPreviousQuote: !!goodQuote
      });

      lastKey = "";
    }
  }

  window.addEventListener("eg:dates", handleDatesEvent, false);
  window.addEventListener("eg:dates-selected", handleDatesEvent, false);
  window.addEventListener("eg:quote-request", handleDatesEvent, false);

  document.addEventListener("eg:units:normalized", function(e) {
    const d = e?.detail || {};
    const rootId = String(d.rootId || "eg-calendar-root");
    const remembered = getRememberedDates(rootId);

    if (!remembered || !remembered.start || !remembered.end) {
      log("units normalized but no remembered dates for root:", rootId);
      return;
    }

    handleDatesEvent({
      detail: {
        rootId,
        start: remembered.start,
        end: remembered.end,
        units: d.units
      }
    });
  }, false);

  log("bound ✅", { QUOTE_URL });
})();